import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';

export function useIsLoyaltyHomepageEnabled(): boolean {
  return useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_HOMEPAGE);
}
